<template>
  <div class="home">
    <app-header style="margin-bottom:3%;"></app-header>
    <app-our-story></app-our-story>
    <app-our-impact></app-our-impact>
    <app-awards></app-awards>
    <app-team></app-team>
    <app-footer></app-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/general/Header.vue";
import OurStory from "@/components/about/OurStory.vue";
import OurImpact from "@/components/about/OurImpact.vue";
import Awards from "@/components/about/Awards.vue";
import TheTeam from "@/components/about/TheTeam.vue";
import Footer from "@/components/general/Footer.vue";


export default {
name: "home",
components: {
  'app-header': Header,
  'app-our-story': OurStory,
  'app-our-impact': OurImpact,
  'app-awards': Awards,
  'app-team': TheTeam,
  'app-footer' : Footer,
  }
}   

</script>
